/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useSelectFile from 'components/hooks/useSelectFile';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';

export default function DroppableDiv({
  onDrop,
  onClick,
  accept,
  allowMimeless,
  multiple,
  disabled,
  children,
  className,
  ...props
}) {
  const [isDragging, setIsDragging] = useState();
  const [isLegalDrag, setIsLegalDrag] = useState(true);
  // const [dragMessage, setDragMessage] = useState('');
  const { openFilePrompt } = useSelectFile();

  const processLegality = (dt) => {
    const { items } = dt;
    if (!items.length) {
      setIsLegalDrag(false);
      return;
    }

    if (!multiple && items.length > 1) {
      setIsLegalDrag(false);
      // setDragMessage('不支援上傳多個檔案');
      return;
    }

    if (!accept) {
      setIsLegalDrag(true);
      return;
    }

    const acceptable = accept.split(',').map((s) => s.trim());
    for (let i = 0; i < items.length; i += 1) {
      if (!items[i].type && allowMimeless) {
        // eslint-disable-next-line no-continue
        continue;
      }
      if (!acceptable.includes(items[i].type)) {
        setIsLegalDrag(false);
        // setDragMessage('錯誤檔案格式');
        return;
      }
    }

    setIsLegalDrag(true);
  };

  return (
    <div
      draggable
      disabled={disabled}
      onClick={onClick || (() => openFilePrompt(accept, multiple).then(onDrop))}
      onDrop={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        setIsDragging(false);
        // setDragMessage('');
        e.preventDefault();
        if (isLegalDrag) {
          onDrop(e.dataTransfer.files);
        }
      }}
      onDragEnd={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        setIsDragging(false);
        e.preventDefault();
      }}
      onDragStart={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
      }}
      onDragEnter={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        processLegality(e.dataTransfer);
        setIsDragging(true);
        e.preventDefault();
      }}
      onDragLeave={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        // setDragMessage('');
        setIsDragging(false);
        e.preventDefault();
      }}
      onDragOver={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
      }}
      onDrag={(e) => { e.preventDefault(); }}
      className={classNames(
        Styles.mainContainer,
        className,
        { [Styles.dragover]: isDragging, [Styles.illegalDrag]: isDragging && !isLegalDrag },
      )}
      {...props}
    >
      {children}
    </div>
  );
}

DroppableDiv.propTypes = {
  onDrop: PropTypes.func,
  onClick: PropTypes.func,
  accept: PropTypes.string,
  allowMimeless: PropTypes.bool,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

DroppableDiv.defaultProps = {
  onDrop: () => {},
  onClick: null,
  allowMimeless: false,
  accept: '',
  multiple: false,
  disabled: false,
  children: null,
  className: '',
};
